import { connect } from 'react-redux';

import ShareDialog from 'shared/components/dialog/ShareDialog';
import {
  clearResentInvites,
  createCollaborator,
  deleteCollaborator,
  fetchCollaborators,
  fetchSharedWithUsers,
  resendCollaboratorInvite,
  setInviteAlias,
  shareBet,
  updateCollaborator,
} from 'shared/redux/actions';
import { shares } from 'shared/redux/selectors';
import { getSharedWithUsers } from 'shared/redux/selectors/contactsSelectors';
import {
  getEmail,
  hasSubscription,
} from 'shared/redux/selectors/userSelectors';

// type: 'sport' || 'atg'

const mapStateToProps = (state, { betId, type }) => ({
  previouslyInvitedEmails: getSharedWithUsers(state),
  userEmail: getEmail(state),
  hasSubscription: hasSubscription(state),
  collaborators: shares.getCollaboratorsList(state, { betId, type }),
  resentInvites: shares.getCompleteResentInvites(state, { betId, type }),
  loadingResentInvites: shares.getLoadingResentInvites(state, { betId, type }),
  isOwner: shares.isOwner(state, { betId, type }),
  collaboratorsError: shares.getCollaboratorsError(state, { betId, type }),
  loading:
    shares.isShareCodeLoading(state, { betId, type }) ||
    shares.isCollaboratorsLoading(state, { betId, type }),
  shareCode: shares.getShareCode(state, { betId, type }),
  shareCodeError: shares.getShareCodeError(state, { betId, type }),
  type,
});

const mapDispatchToProps = (dispatch, { betId, type }) => ({
  createCollaborator: ({ email, collaborateType }) =>
    dispatch(createCollaborator({ betId, type, email, collaborateType })),
  deleteCollaborator: userId =>
    dispatch(deleteCollaborator({ betId, type, userId })),
  fetchCollaborators: () => dispatch(fetchCollaborators({ betId, type })),
  fetchSharedWithUsers: () => dispatch(fetchSharedWithUsers()),
  shareBet: () => dispatch(shareBet({ betId, type })),
  updateCollaborator: ({ userId, collaborateType }) =>
    dispatch(
      updateCollaborator({
        betId,
        userId,
        collaborateType,
        type,
      }),
    ),
  resendCollaboratorInvite: collaboratorId =>
    dispatch(
      resendCollaboratorInvite({
        type,
        betId,
        collaboratorId,
      }),
    ),
  clearResentInvites: () => dispatch(clearResentInvites({ betId, type })),
  setInviteAlias: alias => dispatch(setInviteAlias({ betId, type, alias })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShareDialog);
